function hasChecked(object: any): object is HTMLInputElement {
  return 'checked' in object
}

export interface CheckboxProps {
  label?: string | JSX.Element
  onUpdate: (checked: boolean) => void
  qaClasses?: string
  checked: boolean
  disabled?: boolean
}

const Checkbox = ({ label, onUpdate, qaClasses, checked, disabled }: CheckboxProps) => {
  return (
    <div class='topic-creator__sidebar--checkbox checkbox'>
      <label>
        <input
          type='checkbox'
          class={qaClasses}
          checked={checked}
          disabled={disabled}
          onChange={(e: Event) => {
            if (e.target && hasChecked(e.target)) {
              onUpdate(e.target.checked)
            }
          }}
        />
        {label}
      </label>
    </div>
  )
}

export default Checkbox
